// Mega-menu navigation structure for the public site.
// Each top-level group becomes a dropdown in the desktop nav and an
// expandable panel in the mobile menu. The order here is the order shown.
// Each item maps to /p/<slug> served by the CMS pages backend (/api/pages/:slug).

export const NAV_GROUPS = [
  {
    key: "about",
    label: "About Us",
    items: [
      { slug: "the-asiabest-difference", label: "The Asiabest Difference" },
      { slug: "corporate-history",       label: "Corporate History" },
      { slug: "value-proposition",       label: "Value Proposition" },
      { slug: "conglomerate-map",        label: "Conglomerate Map" },
      { slug: "ownership-structure",     label: "Ownership Structure" },
    ],
  },
  {
    key: "investments",
    label: "Investments",
    items: [
      { slug: "real-estate",                  label: "Real Estate" },
      { slug: "banking-financial-services",   label: "Banking & Financial Services" },
      { slug: "infrastructure",               label: "Infrastructure" },
      { slug: "renewable-energy",             label: "Renewable Energy" },
    ],
  },
  {
    key: "governance",
    label: "Governance",
    items: [
      { slug: "articles-of-incorporation",   label: "Articles of Incorporation, By-laws & GIS" },
      { slug: "manual-on-corporate-governance", label: "Manual on Corporate Governance" },
      { slug: "code-of-business-conduct",    label: "Code of Business Conduct and Ethics" },
      { slug: "company-policies",            label: "Company Policies" },
      { slug: "board-matters",               label: "Board Matters" },
      { slug: "enterprise-risk-management",  label: "Enterprise Risk Management" },
      { slug: "corporate-governance-report", label: "Corporate Governance Report" },
      { slug: "asean-cg-scorecard",          label: "ASEAN Corporate Governance Scorecard" },
      { slug: "annual-stockholders-meeting", label: "Annual Stockholders' Meeting Matters" },
      { slug: "special-stockholders-meeting",label: "Special Stockholders' Meeting" },
    ],
  },
  {
    key: "sustainability",
    label: "Sustainability",
    items: [
      { slug: "eesg-highlights",         label: "EESG Highlights" },
      { slug: "stakeholder-value",       label: "Stakeholder Value" },
      { slug: "sustainability-framework",label: "Sustainability Framework" },
      { slug: "sustainability-reports",  label: "Sustainability Reports" },
    ],
  },
  {
    key: "investor-relations",
    label: "Investor Relations",
    items: [
      { slug: "/disclosures",            label: "Disclosures",        direct: true },
      { slug: "share-information",       label: "Share Information" },
      { slug: "presentations",           label: "Presentations" },
      { slug: "/financial-reports",      label: "Financial Reports",  direct: true },
      { slug: "dividends",               label: "Dividends" },
      { slug: "/news",                   label: "Media Center",       direct: true },
      { slug: "ir-policy",               label: "IR Policy" },
      { slug: "calendar",                label: "Calendar" },
      { slug: "faqs",                    label: "FAQs" },
    ],
  },
  {
    key: "contact",
    label: "Contact Us",
    direct: true,
    href: "/contact",
    items: [],
  },
];

// Helper: get the link path for a nav item
export function navLinkPath(item) {
  if (item.direct) return item.slug;          // already an absolute path
  return `/p/${item.slug}`;
}
